require('../../../styles/blocks/_modal.scss');
require('../../../styles/blocks/_blowup-modal.scss');
require('./RAIndexRiskModal.scss');
require('./RAIndexRiskModal.override.scss');
// @ vendors
const React = require('react');
const PropTypes = require('prop-types');
const Modal = require('react-bootstrap/lib/Modal');
// @ utilities
import { FormattedText } from 'core/i18n';
const UtagHelper = require('utilities/utagHelper');
// @ icons
const closeIcon = require('assets/icons/close.svg');
const petronas = require('assets/icons/buildings/KualaLumpur_modal.svg');
const shangai = require('assets/icons/buildings/Shanghai_modal.svg');
const taipei = require('assets/icons/buildings/Taipei_modal.svg');
const wtc = require('assets/icons/buildings/NewYork_modal.svg');
const khalifa = require('assets/icons/buildings/Dubai_modal.svg');
// @ constants
const {
    EVENT_DETAIL_UNDERSTOOD,
    EVENT_ACTION_RISK_MODAL,
    SIMULATION_GBI_NAME,
    SIMULATION_ROBO_NAME,
    EVENT_DETAIL_VIEW,
    EVENT_DETAIL_BUTTON_CLOSE,
} = require('constants/uTagConstants/RAConstants');
const { PATH_ROBO_INVESTMENT_PLAN, PATH_GBI_INVESTMENT_PLAN } = require('constants/uTagConstants/paths');
const { ROBO } = require('constants/userProfile');

class RAModal extends React.Component {
    componentDidMount() {
        this.recordEvent(EVENT_DETAIL_VIEW);
    }

    handleConfirmButton = () => {
        this.recordEvent(EVENT_DETAIL_UNDERSTOOD);
        this.props.onModalClose();
    };

    handleCloseButton = () => {
        this.recordEvent(EVENT_DETAIL_BUTTON_CLOSE);
        this.props.onModalClose();
    };

    recordEvent = (eventDetail = '') => {
        const { userProfile } = this.props;
        const pathForTag = userProfile.investmentType === ROBO ? PATH_ROBO_INVESTMENT_PLAN : PATH_GBI_INVESTMENT_PLAN;
        const eventCategory = userProfile.investmentType === ROBO ? SIMULATION_ROBO_NAME : SIMULATION_GBI_NAME;
        UtagHelper.recordEventRoboGBI(pathForTag, eventCategory, EVENT_ACTION_RISK_MODAL, eventDetail, userProfile);
    };

    render() {
        const { show, onModalClose } = this.props;

        return (
            <span>
                <Modal
                    show={show}
                    onHide={onModalClose}
                    className="ra-index-risk-modal-override"
                    dialogClassName="ra-index-risk-modal"
                    backdrop="static"
                    animation={true}
                >
                    <Modal.Header>
                        <div className="close-icon">
                            <a
                                href="#"
                                onClick={event => {
                                    event.preventDefault();
                                    this.handleCloseButton();
                                }}
                            >
                                <img src={closeIcon} />
                            </a>
                        </div>
                        <div className="title">
                            <h5>
                                <FormattedText value="raIndexRiskModel-indexModelTitle" />
                            </h5>
                        </div>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="ra-index-risk-modal__parent-div">
                            <div className="ra-index-risk-modal__portfolio-div">
                                <div className="ra-index-risk-modal__icon-div">
                                    <img
                                        className="ra-index-risk-modal__icon ra-index-risk-modal__icon-first-icon"
                                        src={petronas}
                                    />
                                    <div className="ra-index-risk-modal__height-lenght">
                                        <FormattedText value="raIndexRiskModel-shardLength" />
                                    </div>
                                    <div className="ra-index-risk-modal__risk-capacity">
                                        <FormattedText value="raStrategyItem-lowRisk" />
                                    </div>
                                    <div className="ra-index-risk-modal__city--kualalumpur">
                                        <FormattedText value="raIndexRiskModel-petronasCity" />
                                    </div>
                                </div>
                                <div className="ra-index-risk-modal__icon-div">
                                    <img
                                        className="ra-index-risk-modal__icon ra-index-risk-modal__icon-second-icon"
                                        src={shangai}
                                    />
                                    <div className="ra-index-risk-modal__height-lenght">
                                        <FormattedText value="raIndexRiskModel-shangaiLength" />
                                    </div>
                                    <div className="ra-index-risk-modal__risk-capacity">
                                        <FormattedText value="raStrategyItem-midLowRisk" />
                                    </div>
                                    <div className="ra-index-risk-modal__city--shanghai">
                                        <FormattedText value="raIndexRiskModel-shangaiCity" />
                                    </div>
                                </div>
                                <div className="ra-index-risk-modal__icon-div">
                                    <img
                                        className="ra-index-risk-modal__icon ra-index-risk-modal__icon-third-icon"
                                        src={taipei}
                                    />
                                    <div className="ra-index-risk-modal__height-lenght">
                                        <FormattedText value="raIndexRiskModel-petronasLength" />
                                    </div>
                                    <div className="ra-index-risk-modal__risk-capacity">
                                        <FormattedText value="raStrategyItem-midRisk" />
                                    </div>
                                    <div className="ra-index-risk-modal__city--taipei">
                                        <FormattedText value="raIndexRiskModel-raIndexRiskModel_taipeiCity" />
                                    </div>
                                </div>
                                <div className="ra-index-risk-modal__icon-div">
                                    <img
                                        className="ra-index-risk-modal__icon ra-index-risk-modal__icon-fourth-icon"
                                        src={wtc}
                                    />
                                    <div className="ra-index-risk-modal__height-lenght">
                                        <FormattedText value="raIndexRiskModel-wtcLength" />
                                    </div>
                                    <div className="ra-index-risk-modal__risk-capacity">
                                        <FormattedText value="raStrategyItem-midHighRisk" />
                                    </div>
                                    <div className="ra-index-risk-modal__city--newyork">
                                        <FormattedText value="raIndexRiskModel-wtcCity" />
                                    </div>
                                </div>
                                <div className="ra-index-risk-modal__icon-div">
                                    <img
                                        className="ra-index-risk-modal__icon ra-index-risk-modal__icon-fifth-icon"
                                        src={khalifa}
                                    />
                                    <div className="ra-index-risk-modal__height-lenght">
                                        <FormattedText value="raIndexRiskModel-khalifaLength" />
                                    </div>
                                    <div className="ra-index-risk-modal__risk-capacity">
                                        <FormattedText value="raStrategyItem-highRisk" />
                                    </div>
                                    <div className="ra-index-risk-modal__city--dubai">
                                        <FormattedText value="raIndexRiskModel-khalifaCity" />
                                    </div>
                                </div>
                            </div>
                            <div className="ra-index-risk-modal__description-div">
                                <div>
                                    <div className="ra-index-risk-modal__description-icon">
                                        <i className="icons icons--icon-strategy-icon-1--circle" />
                                    </div>
                                    <div className="ra-index-risk-modal__description-details">
                                        <div className="ra-index-risk-modal__description-details-height-portfolio">
                                            <FormattedText value="raIndexRiskModel-shardLength" />
                                        </div>
                                        <div className="ra-index-risk-modal__description-details-city">
                                            <FormattedText value="raIndexRiskModel-petronasCity" />
                                        </div>
                                        <div className="ra-index-risk-modal__description-details-risk-capacity">
                                            <FormattedText value="raIndexRiskModel-shardRiskCapacity" />
                                        </div>
                                        <div className="ra-index-risk-modal__description-details-text">
                                            <FormattedText value="raIndexRiskModel-descriptionForShard" />
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    <div className="ra-index-risk-modal__description-icon">
                                        <i className="icons icons--icon-strategy-icon-2--circle" />
                                    </div>
                                    <div className="ra-index-risk-modal__description-details">
                                        <div className="ra-index-risk-modal__description-details-height-portfolio">
                                            <FormattedText value="raIndexRiskModel-shangaiLength" />
                                        </div>
                                        <div className="ra-index-risk-modal__description-details-city">
                                            <FormattedText value="raIndexRiskModel-shangaiCity" />
                                        </div>
                                        <div className="ra-index-risk-modal__description-details-risk-capacity">
                                            <FormattedText value="raIndexRiskModel-petronasRiskcapacity" />
                                        </div>
                                        <div className="ra-index-risk-modal__description-details-text">
                                            <FormattedText value="raIndexRiskModel-petronasDescription" />
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    <div className="ra-index-risk-modal__description-icon">
                                        <i className="icons icons--icon-strategy-icon-3--circle" />
                                    </div>
                                    <div className="ra-index-risk-modal__description-details">
                                        <div className="ra-index-risk-modal__description-details-height-portfolio">
                                            <FormattedText value="raIndexRiskModel-petronasLength" />
                                        </div>
                                        <div className="ra-index-risk-modal__description-details-city">
                                            <FormattedText value="raIndexRiskModel-raIndexRiskModel_taipeiCity" />
                                        </div>
                                        <div className="ra-index-risk-modal__description-details-risk-capacity">
                                            <FormattedText value="raIndexRiskModel-shangaiRiskCapacity" />
                                        </div>
                                        <div className="ra-index-risk-modal__description-details-text">
                                            <FormattedText value="raIndexRiskModel-shangaiDescription" />
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    <div className="ra-index-risk-modal__description-icon">
                                        <i className="icons icons--icon-strategy-icon-4--circle" />
                                    </div>
                                    <div className="ra-index-risk-modal__description-details">
                                        <div className="ra-index-risk-modal__description-details-height-portfolio">
                                            <FormattedText value="raIndexRiskModel-wtcLength" />
                                        </div>
                                        <div className="ra-index-risk-modal__description-details-city">
                                            <FormattedText value="raIndexRiskModel-wtcCity" />
                                        </div>
                                        <div className="ra-index-risk-modal__description-details-risk-capacity">
                                            <FormattedText value="raIndexRiskModel-wtcRiskCapacity" />
                                        </div>
                                        <div className="ra-index-risk-modal__description-details-text">
                                            <FormattedText value="raIndexRiskModel-wtcDescription" />
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    <div className="ra-index-risk-modal__description-icon">
                                        <i className="icons icons--icon-strategy-icon-5--circle" />
                                    </div>
                                    <div className="ra-index-risk-modal__description-details">
                                        <div className="ra-index-risk-modal__description-details-height-portfolio">
                                            <FormattedText value="raIndexRiskModel-khalifaLength" />
                                        </div>
                                        <div className="ra-index-risk-modal__description-details-city">
                                            <FormattedText value="raIndexRiskModel-khalifaCity" />
                                        </div>
                                        <div className="ra-index-risk-modal__description-details-risk-capacity">
                                            <FormattedText value="raIndexRiskModel-khalifaRiskCapacity" />
                                        </div>
                                        <div className="ra-index-risk-modal__description-details-text">
                                            <FormattedText value="raIndexRiskModel-khalifaDescription" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="ra-index-risk-modal__gradient-div"></div>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <div className="validation-buttons">
                            <button onClick={this.handleConfirmButton}>
                                <FormattedText value="raIndexRiskModel-confirmButtonLabel" />
                            </button>
                        </div>
                    </Modal.Footer>
                </Modal>
            </span>
        );
    }
}

RAModal.propTypes = {
    show: PropTypes.bool,
    onModalClose: PropTypes.func,
};

module.exports = RAModal;
